/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One game's position in the playslip picker. Lower sorts first; a game without a position sorts
 * last. Draw and rapid games only — no other family carries the column.
 * @export
 * @interface GameDisplayOrder
 */
export interface GameDisplayOrder {
    /**
     * 
     * @type {number}
     * @memberof GameDisplayOrder
     */
    displayOrder: number;
    /**
     * The game's GDS id (UUID), the same identifier the branding endpoint takes.
     * @type {string}
     * @memberof GameDisplayOrder
     */
    gameId: string;
}

/**
 * Check if a given object implements the GameDisplayOrder interface.
 */
export function instanceOfGameDisplayOrder(value: object): value is GameDisplayOrder {
    if (!('displayOrder' in value) || value['displayOrder'] === undefined) return false;
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    return true;
}

export function GameDisplayOrderFromJSON(json: any): GameDisplayOrder {
    return GameDisplayOrderFromJSONTyped(json, false);
}

export function GameDisplayOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameDisplayOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'displayOrder': json['displayOrder'],
        'gameId': json['gameId'],
    };
}

export function GameDisplayOrderToJSON(value?: GameDisplayOrder | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'displayOrder': value['displayOrder'],
        'gameId': value['gameId'],
    };
}

